/** Safe rich-text renderer. HTML content is sanitized with DOMPurify;
 * legacy plain-text content keeps the original pre-line rendering. */
import DOMPurify from "dompurify";

const looksLikeHtml = (v) => /<[a-z][\s\S]*>/i.test(v || "") || /&[a-z#0-9]+;/i.test(v || "");

export const RichText = ({ content, className = "", testid }) => {
  if (!content) return null;
  if (!looksLikeHtml(content)) {
    return (
      <div className={`whitespace-pre-line ${className}`} data-testid={testid}>
        {content}
      </div>
    );
  }
  return (
    <div
      className={`rich-text ${className}`}
      data-testid={testid}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content, { USE_PROFILES: { html: true } }) }}
    />
  );
};

export default RichText;
